import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLazyRegisterQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useRegisterApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [registerApi] = useLazyRegisterQuery();
  const send = (data) => {
    dispatch(setLoader(true));
    registerApi(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        navigate("/verify-email", {
          state: {
            verify_token: res?.verify_token,
            email: data?.email,
            method: "signup",
          },
        });
        showToast(res?.label + " " + data?.email ?? "Success", "success");
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useRegisterApi;
